var map = {
	"./assets/download/beijian.png": "0921",
	"./assets/index/beijian.png": "3d13",
	"./assets/solution/ITservice/beijian.png": "83a4",
	"./assets/solution/businessScreen/beijian.png": "616f",
	"./assets/solution/intelFurniture/beijian.png": "521e",
	"./assets/solution/workService/beijian.png": "2004"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a00b";